import React from 'react';

import PropTypes from 'prop-types';

import { getTagDisplay, resolveTagColor } from 'utils/tagColor';

import { Mui } from 'components';

const useStyles = Mui.makeStyles(theme => ({
  root: {
    alignItems: 'flex-start',
    display: 'flex',
    gap: theme.spacing(1.5),
    minWidth: 0,
    padding: theme.spacing(0.25, 0),
  },
  colorDot: {
    borderRadius: '50%',
    flexShrink: 0,
    height: 12,
    marginTop: 4,
    width: 12,
  },
  content: {
    minWidth: 0,
  },
  name: {
    fontWeight: 600,
    lineHeight: 1.3,
  },
  description: {
    display: 'block',
    marginTop: theme.spacing(0.25),
  },
}));

function TagListOption({ tag }) {
  const classes = useStyles();
  const display = getTagDisplay(tag);
  const label = display.name || 'Tag';

  return (
    <Mui.Box className={classes.root}>
      <span
        className={classes.colorDot}
        style={{ backgroundColor: resolveTagColor(display.color) }}
      />
      <Mui.Box className={classes.content}>
        <Mui.Typography className={classes.name} variant="body2">
          {label}
        </Mui.Typography>
        {!!display.description && (
          <Mui.Typography className={classes.description} variant="caption" color="textSecondary">
            {display.description}
          </Mui.Typography>
        )}
      </Mui.Box>
    </Mui.Box>
  );
}

TagListOption.propTypes = {
  tag: PropTypes.object,
};

export default TagListOption;
